<template>
    <Paper class="plusView-manage">
        <div class="micro-app-container" v-loading="loading">
            <template v-if="hasUrl">
                <micro-app  name="otpPlusView" :url="config.otpMicroPlusViewURL" baseroute="/otpPlusView" :data="storeInfo" keep-alive></micro-app>
            </template>
            <template v-else>
                <permission tips="您还没有【otpPlusView】此菜单的访问权限哦～申请权限通过后方能查看" url="https://perm.midea.com/flows/permission/100064?tab=1000000854"></permission>
            </template>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/modules/sn/components/paper/paper';
import config from '@/config/user.env';
/* eslint-disable-next-line */
import microApp from "@micro-zoe/micro-app";
import permission from '@/modules/sn/components/permission';
import { mapGetters } from 'vuex';
// import { getAllResources } from "@/modules/index/api/user";
/* eslint-disable-next-line */
import { EventCenterForMicroApp } from '@micro-zoe/micro-app';

// 注意：每个vite子应用根据appName单独分配一个通信对象
window.eventCenterForViteApp1 = new EventCenterForMicroApp('otpPlusView');

// let isFirstTime = true;
// let checkHasUrl = false;
export default {
    components: {
        permission,
        Paper
    },
    data() {
        return {
            config,
            storeInfo: {},
            ilsUrl: '',
            hasUrl: true,
            loading: false
        };
    },
    methods: {
    },
    computed: {
        ...mapGetters([
            'user',
            'authority',
            'currentTenant',
            'appId',
            'tenantInfo',
            'appList',
            'applicationCode',
            'btnPermissions'
        ])
    },
    mounted() {
        // console.log('进来 plus view的微前端。。。')
        // console.log(config.otpMicroPlusViewURL)
        const {
            user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            btnPermissions
        } = this;
        this.storeInfo = {
            user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            btnPermissions,
            vue2Root: this.$root
        };
    },
    watch: {
        $route: {
            handler(val, oldVal) {
                microApp.setData('otpPlusView', { path: val.path });
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style scoped lang="less">
.micro-app-container {
    position: relative;
    width: 100%;
    height: 100%;
}
micro-app, micro-app-body {
    height: 100%;
}

/* el-dropdown__popper el-popper */
</style>
<style lang="less">
.plusView-manage {
    margin: 0 !important;
    padding: 0 !important;
}
body .el-dropdown__popper {
    .el-dropdown-menu {
        position: relative !important;
    }
}

micro-app[name="otpPlusView"] {
    .details-header-fixed {
        position: static !important;
    }
    .details-page-spacing {
        margin-top: 10px !important;
    }
}
</style>
